import React from 'react';

export default function SubscriptionAwareness() {
  const heatmapData = [
    { brand: 'Ollie', totalAware: 95.5, unaided: 3.5 },
    { brand: 'Spot & Tango', totalAware: 97, unaided: 3.4 },
    { brand: 'Nom Nom', totalAware: 97.7, unaided: 2.3 },
    { brand: 'The Farmer\'s Dog', totalAware: 95.9, unaided: 3.4 },
    { brand: 'Bark Box', totalAware: 95.9, unaided: 13.1 },
    { brand: 'The Honest Kitchen', totalAware: 91.9, unaided: 8.1 },
    { brand: 'Chewy', totalAware: 92.8, unaided: 7.1 },
    { brand: 'Petco', totalAware: 70.8, unaided: 29.1 },
    { brand: 'PetSmart', totalAware: 72.5, unaided: 27.5 },
    { brand: 'Amazon', totalAware: 77.9, unaided: 22.1 },
    { brand: 'Walmart+', totalAware: 93.1, unaided: 36.9 },
    { brand: 'Retail Rival', totalAware: 93.7, unaided: 3.5 },
    { brand: 'Just for Dogs', totalAware: 95.7, unaided: 3.3 },
    { brand: 'Open Farm', totalAware: 97.1, unaided: 2.9 },
    { brand: 'The Honest Kitchen', totalAware: 94.9, unaided: 3.4 }
  ];

  const getColor = () => {
    return '#EF4444'; // Bright red
  };

  return (
   <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-4 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">Subscription Awareness & Usage</h1>
 

      {/* Main Content Grid */}
      <div className="grid grid-cols-2 gap-6">
        {/* Left Side - Heatmap */}
        <div>
          <h2 className="text-base font-bold mb-3">Top Awareness Brands Heatmap</h2>
          
          {/* Heatmap Table */}
          <div className="border border-gray-200">
            {/* Header Row */}
            <div className="grid grid-cols-3 bg-white border-b border-gray-200">
              <div className="p-1 font-bold text-sm border-r-1 border-gray-200">Brand</div>
              <div className="p-1 font-bold text-sm text-center bg-[#aee772] border-r-1 border-gray-200">
                Total Aware (%)
              </div>
              <div className="p-1 font-bold text-sm text-center bg-red-500 text-white">
                Unaided (%)
              </div>
            </div>
            
            {/* Data Rows */}
            {heatmapData.map((row, index) => (
              <div key={index} className="grid grid-cols-3 border-b border-gray-200">
                <div className="p-1 text-sm border-r-1 border-gray-200">{row.brand}</div>
                <div className="p-1 text-sm text-center bg-[#aee772] border-r-1 border-gray-200">
                  {row.totalAware}
                </div>
                <div 
                  className={`p-1 text-sm text-center font-semibold bg-[${getColor()}]`}
                >
                  {row.unaided}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Insights */}
        <div className="space-y-2">
          {/* Box 1 - Overall Awareness */}
          <div className="bg-[#aee772] border-2  p-2 rounded-xl">
            <p className="text-sm leading-relaxed">
              <span className="font-bold">Overall awareness of subscriptions is extremely high ~97%</span> (nearly 
              all dog owners are familiar with at least one subscription service), making 
              this category highly prominent.
            </p>
          </div>

          {/* Box 2 - Top Brands */}
          <div className="bg-[#aee772] border-2  p-2 rounded-xl">
            <p className="text-sm font-bold mb-2">Top brands dominate awareness</p>
            <p className="text-sm mb-2">The highest recognition brands are:</p>
            <div className="grid grid-cols-2 gap-2 mb-3">
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Ollie (96.5%)</span></span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Spot & Tango (97%)</span></span>
                </li>
              </ul>
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Nom Nom (97.7%)</span></span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">We Feed Raw (96.6%)</span></span>
                </li>
              </ul>
            </div>
            <p className="text-sm leading-relaxed">
              These specialty subscription brands lead in recognition, indicating 
              strong marketing visibility.
            </p>
          </div>

          {/* Box 3 - Lower Awareness */}
          <div className="bg-[#aee772] border-2  p-2 rounded-xl">
            <p className="text-sm font-bold mb-2">
              Lower awareness is concentrated among retail-based auto-ship brands
            </p>
            <p className="text-sm mb-2">Notably lower recognition for:</p>
            <div className="grid grid-cols-2 gap-2 mb-3">
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">PetSmart (72.5%)</span></span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Petco (71%)</span></span>
                </li>
              </ul>
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Walmart+ (93%)</span></span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">Amazon (78%)</span></span>
                </li>
              </ul>
            </div>
            <p className="text-sm leading-relaxed">
              These services focus more on general retail familiarity rather than subscription-
              specific branding, resulting in weaker awareness.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
}